import { render } from "./MealQuantityButton.vue?vue&type=template&id=4cc12d8e&scoped=true"
import script from "./MealQuantityButton.vue?vue&type=script&lang=js"
export * from "./MealQuantityButton.vue?vue&type=script&lang=js"

import "./MealQuantityButton.vue?vue&type=style&index=0&id=4cc12d8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc12d8e"]])

export default __exports__